import { Button } from '@/shared/ui/primitives';
import type { FC } from 'react';

import { TEST_IDS } from '@/testIds';
import { ModalDeleteButton, ModalFooter } from '@/shared/ui';

interface PassModalFooterProps {
  isEdit: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  canDelete: boolean;
  onDelete: () => void;
}

export const PassModalFooter: FC<PassModalFooterProps> = ({
  isEdit,
  isLoading,
  isSubmitting,
  canDelete,
  onDelete,
}) => (
  <ModalFooter>
    <Button
      variant="primary"
      type="submit"
      fullWidth
      disabled={isSubmitting || isLoading}
      loading={isSubmitting || isLoading}
      data-testid={isEdit ? TEST_IDS.updatePassButton : TEST_IDS.savePassButton}
    >
      {isLoading ? 'Saving...' : isEdit ? 'Save changes' : 'Add pass'}
    </Button>
    {isEdit && canDelete && (
      <ModalDeleteButton
        label="Delete pass"
        onClick={onDelete}
        disabled={isSubmitting || isLoading}
        testId={TEST_IDS.deletePassButton}
      />
    )}
  </ModalFooter>
);
